export default __webpack_public_path__ + "static/media/video_placeholder.c547ad0d.png";